import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="MVP">
                <h1>MVP Development Services</h1>
              </div>
              <p className="main_para">
                Accelerate your time to market through cost-effective MVP
                software development.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                TekRevol is experienced in designing, developing, and launching
                minimum viable products. Our MVP development services are your
                way to a successful digital campaign.
              </p>
              <ul>
                <li>Study &amp; Ideation</li>
                <li>MVP Architecture Design</li>
                <li>Roadmap Definition</li>
                <li>User Acquisition Modeling</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
